export default __webpack_public_path__ + "static/media/pork.98f99006.98f99006.svg";